import { MobileDisplayContainer } from '@components/DeviceContainer'
import React from 'react'
import styled from 'styled-components'
import useR18Alert from './useR18Alert'
import tw from 'twin.macro'

const ModalContainer = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000000;
  background-color: #2c2593;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ModalContentContainer = styled.div`
  color: white;
  padding: 0px 60px;
`

const LollipopImage = styled.img`
  display: block;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  margin-bottom: 10px;
`

const TitleContainer = styled.div`
  ${tw`font-semibold text-article`}
  text-align: center;
  margin-top: 24px;
`

const DescriptionContainer = styled.div`
  ${tw`text-h6`}
  margin-top: 8px;
`

const YesMessageContainer = styled.div`
  cursor: pointer;
  margin-top: 40px;
  ${tw`bg-primary-indigo`}
  text-align: center;
  height: 56px;
  border-radius: 28px;
  line-height: 56px;
`

const NoMessageContainer = styled.div`
  cursor: pointer;
  color: black;
  margin-top: 8px;
  height: 56px;
  border-radius: 28px;
  line-height: 56px;
  text-align: center;
  background-color: white;
`

const MobileR18Alert = () => {
  const { title, description, noMessage, yesMessage, handleYesClick, handleNoClick, shouldShow } =
    useR18Alert()
  if (!shouldShow) {
    return null
  }
  return (
    <MobileDisplayContainer>
      <ModalContainer>
        <ModalContentContainer>
          <LollipopImage src={'/images/r18Alert/hey-lollipop.png'} />
          <TitleContainer>{title}</TitleContainer>
          <DescriptionContainer>{description}</DescriptionContainer>
          <YesMessageContainer onClick={handleYesClick}>{yesMessage}</YesMessageContainer>
          <NoMessageContainer onClick={handleNoClick}>{noMessage}</NoMessageContainer>
        </ModalContentContainer>
      </ModalContainer>
    </MobileDisplayContainer>
  )
}

export default MobileR18Alert
